import { ModelApiService } from './BaseApiService'

export default class PendingBookingsApiService extends ModelApiService {
  constructor() {
    super('pending-bookings')
  }

  async action({ bookingId, action, reason }) {
    return this.post(`${bookingId}/action`, { action, reason })
  }
}
